import React, { useEffect, useRef, useState } from "react";

import styles from "./Beverage.module.css";
import { Message } from "./components/Message";
import { useBeveragesV4 } from "./useBeveragesV4";
import { Actions } from "./components/Actions";
import { beverageActionTypes, messageTypes } from "./BeverageConstants";
import { sendPageViewWhenConsentReady } from "../../utils/adobeDataLayerUtils";

export const BeverageV4 = () => {
  const timeout = useRef(null);
  const [showLoader, setShowLoader] = useState(false);
  const { messages, action, next, isAnsweringConsent } = useBeveragesV4();
  // This is needed to show all previous messages instantly after login
  const startAnimationFrom = useRef(0);
  const [postedMessages, setPostedMessages] = useState([]);
  const messagesRef = useRef(null);

  const scheduleMessageAdd = (postedMessages) => {
    const hasMore = postedMessages.length < messages.length;
    setShowLoader(hasMore);
    if (hasMore) {
      timeout.current = setTimeout(
        () => {
          const newPostedMessages = [
            ...postedMessages,
            messages[postedMessages.length],
          ];
          setPostedMessages(newPostedMessages);
          scheduleMessageAdd(newPostedMessages);
        },
        messages[postedMessages.length]?.isBot &&
          startAnimationFrom.current < postedMessages.length
          ? 1000
          : 0,
      );
    }
  };

  useEffect(() => {
    return sendPageViewWhenConsentReady("Beverage V4 Page", 'Passions-FavBevs', 'beverages4');
  }, []);

  useEffect(() => {
    startAnimationFrom.current = messages.length > 3 ? messages.length : 0;
  }, []);

  useEffect(() => {
    clearTimeout(timeout.current);
    if (messages.length < postedMessages.length) {
      setPostedMessages(messages);
    } else {
      scheduleMessageAdd(postedMessages);
    }
  }, [messages]);

  useEffect(() => {
    queueMicrotask(() => {
      if (messagesRef.current) {
        messagesRef.current.scrollTo(0, messagesRef.current.scrollHeight);
      }
    });
  }, [postedMessages]);

  return (
    <section className={styles.chat}>
      <ul ref={messagesRef} className={styles.chatMessages}>
        {postedMessages.map((message, i) => (
          <li key={i}>
            <Message {...message}></Message>
          </li>
        ))}
        {(showLoader && messages[postedMessages.length].isBot) ||
        action?.type === beverageActionTypes.TextDisabled ? (
          <Message
            additionalClasses={[styles.loaderMessage]}
            isBot={true}
            messageType={messageTypes.Text}
            message={`<div class=${styles.loader}></div>`}
          />
        ) : null}
      </ul>
      <Actions
        action={action}
        next={next}
        isAnsweringConsent={isAnsweringConsent}
      ></Actions>
    </section>
  );
};
